import { render, staticRenderFns } from "./uploadFileAndImgBtn.vue?vue&type=template&id=ea809d60&scoped=true&"
import script from "./uploadFileAndImgBtn.vue?vue&type=script&lang=js&"
export * from "./uploadFileAndImgBtn.vue?vue&type=script&lang=js&"
import style0 from "./uploadFileAndImgBtn.vue?vue&type=style&index=0&id=ea809d60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea809d60",
  null
  
)

component.options.__file = "uploadFileAndImgBtn.vue"
export default component.exports